var map = {
	"./de-DE.json": [
		2901,
		2
	],
	"./en-GB.json": [
		2902,
		3
	],
	"./en-US.json": [
		2903,
		4
	],
	"./es-419.json": [
		2904,
		5
	],
	"./es-ES.json": [
		2905,
		6
	],
	"./fr-CA.json": [
		2906,
		7
	],
	"./fr-FR.json": [
		2907,
		8
	],
	"./id-ID.json": [
		2908,
		9
	],
	"./it-IT.json": [
		2909,
		10
	],
	"./ja-JP.json": [
		2910,
		11
	],
	"./nl-NL.json": [
		2911,
		12
	],
	"./pt-BR.json": [
		2912,
		13
	],
	"./zh-CN.json": [
		2913,
		14
	],
	"./zh-Hans-CN.json": [
		2914,
		15
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1629;
module.exports = webpackAsyncContext;